import type { BrandJson } from "@coras-io/brand-tokens";
import {
  DEFAULT_CURRENCIES,
  DEFAULT_LOCALES,
  type SiteConfig,
} from "../../src/types";
import brandConfig from "./brand.json";

export const brand = brandConfig as BrandJson;

export const site: SiteConfig = {
  distributorId: "852c7b67c6074b35a890ef5f4baa837b",
  title: "TourOptima",
  description: "Book tours, activities and experiences",
  locale: "en-US",
  currency: "EUR",
  locales: DEFAULT_LOCALES,
  currencies: DEFAULT_CURRENCIES,
  favicons: ["favicon.png", "apple-touch-icon.png"],
  logo: "/assets/images/logo.svg",
  domain: "tickets.touroptima.com",
  detectLocale: true,
  detectCurrency: false,
};
